export default __webpack_public_path__ + "static/media/acolyte_004.2419568b.jpg";